module.exports = "<a class=\"carrito-externo\" href=\"carrito\">\r\n  <span class=\"badge numero-carrito\">{{count}}</span>\r\n  <div class=\"carrito-interno fa fa-shopping-cart\"></div>\r\n</a>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/floatButtonCart/floatButtonCart.html
// module id = 570
// module chunks = 1